import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

// TODO: Delete all scss and css please!!
import './index.css';
import './mobile.css';
import './medium.css';
import './large.css';
import './styles/main.scss';

import App from '@containers/App';
import gtmInit from '@helpers/gtm';
import './i18n';

gtmInit();

ReactDOM.hydrate(
  <Suspense fallback={<div />}>
    <App />
  </Suspense>,
  document.getElementById('root')
);
